
export interface INavElementsEdge {
   key: string;
   rev: string;
   id: string;
   from: string;
   to: string;
   group: string;
   label: string;
   titel?: string;
   aktion?: string;
   display?: boolean;
   createDefaults?: boolean; // Sollen defaults Schaltungs-Komponenten Kanten erstellt werden
   createComponentDefaults?: boolean; // defaults Schaltungs-Komponenten Kanten erstellt werden für Komponente --> Anlage Kante.
   createFGConnection?: boolean; // Soll eine manuell ausgelöste FG trotzdem die Kante zum DTB bzw SG kriegen?
}

export class NavElementsEdgeGroup {

   public _children: INavElementsEdge[] = [];

   constructor(
      private _name: string
   ) { }

   // set/get
   public get name() { return this._name; }

   // add Child
   public addChild(child: INavElementsEdge) {
      let exist = false;

      this._children.forEach((item: INavElementsEdge) => {
         if (item.id === child.id) {
            exist = true;
            return;
         }
      });

      if (!exist) {
         this._children.push(child);
      }
   }
}



// WEBPACK FOOTER //
// /builds/cp/frap/t3/planer/src/app/nav/model/nav-elements-edgegroup.ts